import React, { useEffect } from 'react';

import SchemaBase from '../../SchemaBase/SchemaBase';

import { useTranslate } from 'react-polyglot';
import { Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';



// Schema for registering an application to use your dog in breeding
function SchemaBreedReg(props: SchemaBreedRegProps) {
    const t = useTranslate();
    const params = useParams();

    const [application, setApplication] = React.useState({
        // Owner Information
        ownerEmail: '',
        ownerName: '',
        address: '',
        postalCode: '',
        city: '',
        phone: '',

        // Dog Information
        regNum: '',
        dogName: '',
        sex: '',
        availableFor: '',
        bestShowAward: '',
        completedHuntTest: '',
        bestHuntAward: '',
        champion: [] as string[],
        championOtherText: '',

        // Sickness Information
        pnp: '',
        epilepsy: '',
        lungEdema: '',
        dermocysts: '',
        allergy: '',
        glaucoma: '',
        dwarfGrowth: '',
        otherSickness: '',
        otherSicknessText: '',
        confirmation: '',
        confirmationText: '',
    });

    function divider(header?: string, description?: string) {
        return (
            <div className="divider">
                <hr/>
                {header && <h2>{header}</h2>}
                {description && <p>{description}</p>}
            </div>
        );
    }
    
    return (
        <SchemaBase
            title={t('schema.breedreg.title')}
            description={t('schema.breedreg.description')}
            schema={application}
            schemaKey={"breedreg"}
            breedId={params.breedid}
        >
            <div className="breedreg">
                {divider(t('schema.breedreg.ownertitle'))}
                <div className="inputfield"> {/* Email */}
                    <Form.Label htmlFor="inputOwnerEmail">{t('schema.breedreg.owneremail.label')}</Form.Label>
                    <Form.Control
                        id="inputOwnerEmail"
                        aria-describedby="ownerEmailHelpBlock"
                        value={application.ownerEmail}
                        onChange={(e) => setApplication({...application, ownerEmail: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Owner Name */}
                    <Form.Label htmlFor="inputOwnerName">{t('schema.breedreg.ownername.label')}</Form.Label>
                    <Form.Control
                        id="inputOwnerName"
                        aria-describedby="ownerNameHelpBlock"
                        value={application.ownerName}
                        onChange={(e) => setApplication({...application, ownerName: e.target.value})}
                    />
                    {/* <Form.Text id="ownerNameHelpBlock" muted>
                        {t('schema.breedreg.ownername.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Address */}
                    <Form.Label htmlFor="inputAddress">{t('schema.breedreg.address.label')}</Form.Label>
                    <Form.Control
                        id="inputAddress"
                        aria-describedby="addressHelpBlock"
                        value={application.address}
                        onChange={(e) => setApplication({...application, address: e.target.value})}
                    />
                    {/* <Form.Text id="addressHelpBlock" muted>
                        {t('schema.breedreg.address.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Postal Code */}
                    <Form.Label htmlFor="inputPostalCode">{t('schema.breedreg.postalcode.label')}</Form.Label>
                    <Form.Control
                        id="inputPostalCode"
                        aria-describedby="postalCodeHelpBlock"
                        value={application.postalCode}
                        onChange={(e) => setApplication({...application, postalCode: e.target.value})}
                    />
                    {/* <Form.Text id="postalCodeHelpBlock" muted>
                        {t('schema.breedreg.postalcode.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* City */}
                    <Form.Label htmlFor="inputCity">{t('schema.breedreg.city.label')}</Form.Label>
                    <Form.Control
                        id="inputCity"
                        aria-describedby="cityHelpBlock"
                        value={application.city}
                        onChange={(e) => setApplication({...application, city: e.target.value})}
                    />
                    {/* <Form.Text id="cityHelpBlock" muted>
                        {t('schema.breedreg.city.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Phone */}
                    <Form.Label htmlFor="inputPhone">{t('schema.breedreg.phone.label')}</Form.Label>
                    <Form.Control
                        id="inputPhone"
                        aria-describedby="phoneHelpBlock"
                        value={application.phone}
                        onChange={(e) => setApplication({...application, phone: e.target.value})}
                    />
                    {/* <Form.Text id="phoneHelpBlock" muted>
                        {t('schema.breedreg.phone.help')}
                    </Form.Text> */}
                </div>
                {divider(t('schema.breedreg.doginfotitle'))}
                <div className="inputfield"> {/* Registration Number */}
                    <Form.Label htmlFor="inputRegNum">{t('schema.breedreg.regnum.label')}</Form.Label>
                    <Form.Control
                        id="inputRegNum"
                        aria-describedby="regNumHelpBlock"
                        value={application.regNum}
                        onChange={(e) => setApplication({...application, regNum: e.target.value})}
                    />
                    {/* <Form.Text id="regNumHelpBlock" muted>
                        {t('schema.breedreg.regnum.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Dog Name */}
                    <Form.Label htmlFor="inputDogName">{t('schema.breedreg.dogname.label')}</Form.Label>
                    <Form.Control
                        id="inputDogName"
                        aria-describedby="dogNameHelpBlock"
                        value={application.dogName}
                        onChange={(e) => setApplication({...application, dogName: e.target.value})}
                    />
                    {/* <Form.Text id="dogNameHelpBlock" muted>
                        {t('schema.breedreg.dogname.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Sex */}
                    <Form.Label htmlFor="inputSex">{t('schema.breedreg.sex.label')}</Form.Label>
                    <Form.Check
                        type={'radio'}
                        id="inputSexMale"
                        name={"inputSex"}
                        label={t('schema.breedreg.sex.options.male')}
                        aria-describedby="sexHelpBlock"
                        checked={application.sex == "male"}
                        onChange={(e) => setApplication({...application, sex: "male"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputSexFemale"
                        name={"inputSex"}
                        label={t('schema.breedreg.sex.options.female')}
                        aria-describedby="sexHelpBlock"
                        checked={application.sex == "female"}
                        onChange={(e) => setApplication({...application, sex: "female"})}
                    />
                    {/* <Form.Text id="sexHelpBlock" muted>
                        {t('schema.breedreg.sex.help')}</Form.Label>
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Available For */}
                    <Form.Label htmlFor="inputAvailableFor">{t('schema.breedreg.availablefor.label')}</Form.Label>
                    <Form.Check
                        type={'radio'}
                        id="inputAvailableForLoose"
                        name={"inputAvailableFor"}
                        label={t('schema.breedreg.availablefor.options.loose')}
                        aria-describedby="availableForHelpBlock"
                        checked={application.availableFor == "loose"}
                        onChange={(e) => setApplication({...application, availableFor: "loose"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputAvailableForTethered"
                        name={"inputAvailableFor"}
                        label={t('schema.breedreg.availablefor.options.tethered')}
                        aria-describedby="availableForHelpBlock"
                        checked={application.availableFor == "tethered"}
                        onChange={(e) => setApplication({...application, availableFor: "tethered"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputAvailableForBoth"
                        name={"inputAvailableFor"}
                        label={t('schema.breedreg.availablefor.options.both')}
                        aria-describedby="availableForHelpBlock"
                        checked={application.availableFor == "both"}
                        onChange={(e) => setApplication({...application, availableFor: "both"})}
                    />
                    {/* <Form.Text id="availableForHelpBlock" muted>
                        {t('schema.breedreg.availablefor.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Best Show Award */}
                    <Form.Label htmlFor="inputBestShowAward">{t('schema.breedreg.bestshowaward.label')}</Form.Label>
                    <Form.Check
                        type={'radio'}
                        id="inputBestShowAwardG"
                        name={"inputBestShowAward"}
                        label={t('schema.breedreg.bestshowaward.options.g')}
                        aria-describedby="bestShowAwardHelpBlock"
                        checked={application.bestShowAward == "g"}
                        onChange={(e) => setApplication({...application, bestShowAward: "g"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputBestShowAwardVG"
                        name={"inputBestShowAward"}
                        label={t('schema.breedreg.bestshowaward.options.vg')}
                        aria-describedby="bestShowAwardHelpBlock"
                        checked={application.bestShowAward == "vg"}
                        onChange={(e) => setApplication({...application, bestShowAward: "vg"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputBestShowAwardExc"
                        name={"inputBestShowAward"}
                        label={t('schema.breedreg.bestshowaward.options.exc')}
                        aria-describedby="bestShowAwardHelpBlock"
                        checked={application.bestShowAward == "exc"}
                        onChange={(e) => setApplication({...application, bestShowAward: "exc"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputBestShowAwardCK"
                        name={"inputBestShowAward"}
                        label={t('schema.breedreg.bestshowaward.options.ck')}
                        aria-describedby="bestShowAwardHelpBlock"
                        checked={application.bestShowAward == "ck"}
                        onChange={(e) => setApplication({...application, bestShowAward: "ck"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputBestShowAwardCERT"
                        name={"inputBestShowAward"}
                        label={t('schema.breedreg.bestshowaward.options.cert')}
                        aria-describedby="bestShowAwardHelpBlock"
                        checked={application.bestShowAward == "cert"}
                        onChange={(e) => setApplication({...application, bestShowAward: "cert"})}
                    />
                    {/* <Form.Text id="bestShowAwardHelpBlock" muted>
                        {t('schema.breedreg.bestshowaward.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Completed Hunt Test */}
                    <Form.Label htmlFor="inputCompletedHuntTest">{t('schema.breedreg.completedhunttest.label')}</Form.Label>
                    <Form.Check
                        type={'radio'}
                        id="inputCompletedHuntTestLeash"
                        name={"inputCompletedHuntTest"}
                        label={t('schema.breedreg.completedhunttest.options.leash')}
                        aria-describedby="completedHuntTestHelpBlock"
                        checked={application.completedHuntTest == "leash"}
                        onChange={(e) => setApplication({...application, completedHuntTest: "leash"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputCompletedHuntTestLoose"
                        name={"inputCompletedHuntTest"}
                        label={t('schema.breedreg.completedhunttest.options.loose')}
                        aria-describedby="completedHuntTestHelpBlock"
                        checked={application.completedHuntTest == "loose"}
                        onChange={(e) => setApplication({...application, completedHuntTest: "loose"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputCompletedHuntTestBoth"
                        name={"inputCompletedHuntTest"}
                        label={t('schema.breedreg.completedhunttest.options.both')}
                        aria-describedby="completedHuntTestHelpBlock"
                        checked={application.completedHuntTest == "both"}
                        onChange={(e) => setApplication({...application, completedHuntTest: "both"})}
                    />
                </div>
                <div className="inputfield"> {/* Best Hunt Award */}
                    <Form.Label htmlFor="inputBestHuntAward">{t('schema.breedreg.besthuntaward.label')}</Form.Label>
                    <Form.Select
                        id="inputBestHuntAward"
                        aria-describedby="bestHuntAwardHelpBlock"
                        value={application.bestHuntAward}
                        onChange={(e) => setApplication({...application, bestHuntAward: e.target.value})}
                    >
                        <option>{t('schema.breedreg.besthuntaward.options.select')}</option>
                        <option value="1">{t('schema.breedreg.besthuntaward.options.first')}</option>
                        <option value="2">{t('schema.breedreg.besthuntaward.options.second')}</option>
                        <option value="3">{t('schema.breedreg.besthuntaward.options.third')}</option>
                        <option value="0">{t('schema.breedreg.besthuntaward.options.none')}</option>
                    </Form.Select>
                    {/* <Form.Text id="bestHuntAwardHelpBlock" muted>
                        {t('schema.breedreg.besthuntaward.help')}
                    </Form.Text> */}
                </div>
                <div className="inputfield"> {/* Champion */}
                    <Form.Label htmlFor="inputChampion">{t('schema.breedreg.champion.label')}</Form.Label>
                    <Form.Check
                        type={'checkbox'}
                        id="inputChampionNBJCH"
                        name={"inputChampion"}
                        label={t('schema.breedreg.champion.options.nbjch')}
                        aria-describedby="championHelpBlock"
                        checked={application.champion.includes("nbjch") ? true : false}
                        onChange={(e) => {
                            if (application.champion.includes("nbjch")) {
                                setApplication({...application, champion: application.champion.filter((value) => value != "nbjch")});
                            } else {
                                setApplication({...application, champion: [...application.champion, "nbjch"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputChampionNLJCH"
                        name={"inputChampion"}
                        label={t('schema.breedreg.champion.options.nljch')}
                        aria-describedby="championHelpBlock"
                        checked={application.champion.includes("nljch") ? true : false}
                        onChange={(e) => {
                            if (application.champion.includes("nljch")) {
                                setApplication({...application, champion: application.champion.filter((value) => value != "nljch")});
                            } else {
                                setApplication({...application, champion: [...application.champion, "nljch"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputChampionNUCH"
                        name={"inputChampion"}
                        label={t('schema.breedreg.champion.options.nuch')}
                        aria-describedby="championHelpBlock"
                        checked={application.champion.includes("nuch") ? true : false}
                        onChange={(e) => {
                            if (application.champion.includes("nuch")) {
                                setApplication({...application, champion: application.champion.filter((value) => value != "nuch")});
                            } else {
                                setApplication({...application, champion: [...application.champion, "nuch"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputChampionOther"
                        name={"inputChampion"}
                        label={t('schema.breedreg.champion.options.other')}
                        aria-describedby="championHelpBlock"
                        checked={application.champion.includes("other") ? true : false}
                        onChange={(e) => {
                            if (application.champion.includes("other")) {
                                setApplication({...application, champion: application.champion.filter((value) => value != "other")});
                            } else {
                                setApplication({...application, champion: [...application.champion, "other"]});
                            }
                        }}
                    />
                    <Form.Control
                        id="inputChampionOtherText"
                        aria-describedby="championHelpBlock"
                        value={application.championOtherText}
                        onChange={(e) => setApplication({...application, championOtherText: e.target.value})}
                    />
                    {/* <Form.Text id="championHelpBlock" muted>
                        {t('schema.breedreg.champion.help')}
                    </Form.Text> */}
                </div>
                {divider(t('schema.breedreg.sicknesstitle'), t('schema.breedreg.sicknessdescription'))}
                <div className="inputfield"> {/* PNP */}
                    <Form.Label htmlFor="inputPNP">{t('schema.breedreg.pnp.label')}</Form.Label>
                    <br />
                    <Form.Text id="pnpHelpBlock" muted>
                        {t('schema.breedreg.pnp.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputPNPYes"
                        name={"inputPNP"}
                        label={t('schema.breedreg.pnp.options.yes')}
                        aria-describedby="pnpHelpBlock"
                        checked={application.pnp == "yes"}
                        onChange={(e) => setApplication({...application, pnp: "yes"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputPNPNo"
                        name={"inputPNP"}
                        label={t('schema.breedreg.pnp.options.no')}
                        aria-describedby="pnpHelpBlock"
                        checked={application.pnp == "no"}
                        onChange={(e) => setApplication({...application, pnp: "no"})}
                    />
                </div>
                <div className="inputfield"> {/* Epilepsy */}
                    <Form.Label htmlFor="inputEpilepsy">{t('schema.breedreg.epilepsy.label')}</Form.Label>
                    <br />
                    <Form.Text id="epilepsyHelpBlock" muted>
                        {t('schema.breedreg.epilepsy.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputEpilepsyYes"
                        name={"inputEpilepsy"}
                        label={t('schema.breedreg.epilepsy.options.yes')}
                        aria-describedby="epilepsyHelpBlock"
                        checked={application.epilepsy == "yes"}
                        onChange={(e) => setApplication({...application, epilepsy: "yes"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputEpilepsyNo"
                        name={"inputEpilepsy"}
                        label={t('schema.breedreg.epilepsy.options.no')}
                        aria-describedby="epilepsyHelpBlock"
                        checked={application.epilepsy == "no"}
                        onChange={(e) => setApplication({...application, epilepsy: "no"})}
                    />
                </div>
                <div className="inputfield"> {/* Lung Edema */}
                    <Form.Label htmlFor="inputLungEdema">{t('schema.breedreg.lungedema.label')}</Form.Label>
                    <br />
                    <Form.Text id="lungEdemaHelpBlock" muted>
                        {t('schema.breedreg.lungedema.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputLungEdemaYes"
                        name={"inputLungEdema"}
                        label={t('schema.breedreg.lungedema.options.yes')}
                        aria-describedby="lungEdemaHelpBlock"
                        checked={application.lungEdema == "yes"}
                        onChange={(e) => setApplication({...application, lungEdema: "yes"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputLungEdemaNo"
                        name={"inputLungEdema"}
                        label={t('schema.breedreg.lungedema.options.no')}
                        aria-describedby="lungEdemaHelpBlock"
                        checked={application.lungEdema == "no"}
                        onChange={(e) => setApplication({...application, lungEdema: "no"})}
                    />
                </div>
                <div className="inputfield"> {/* Dermocysts */}
                    <Form.Label htmlFor="inputDermocysts">{t('schema.breedreg.dermocysts.label')}</Form.Label>
                    <br />
                    <Form.Text id="dermocystsHelpBlock" muted>
                        {t('schema.breedreg.dermocysts.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputDermocystsYes"
                        name={"inputDermocysts"}
                        label={t('schema.breedreg.dermocysts.options.yes')}
                        aria-describedby="dermocystsHelpBlock"
                        checked={application.dermocysts == "yes"}
                        onChange={(e) => setApplication({...application, dermocysts: "yes"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputDermocystsNo"
                        name={"inputDermocysts"}
                        label={t('schema.breedreg.dermocysts.options.no')}
                        aria-describedby="dermocystsHelpBlock"
                        checked={application.dermocysts == "no"}
                        onChange={(e) => setApplication({...application, dermocysts: "no"})}
                    />
                </div>
                <div className="inputfield"> {/* Allergy */}
                    <Form.Label htmlFor="inputAllergy">{t('schema.breedreg.allergy.label')}</Form.Label>
                    <br />
                    <Form.Text id="allergyHelpBlock" muted>
                        {t('schema.breedreg.allergy.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputAllergyYes"
                        name={"inputAllergy"}
                        label={t('schema.breedreg.allergy.options.yes')}
                        aria-describedby="allergyHelpBlock"
                        checked={application.allergy == "yes"}
                        onChange={(e) => setApplication({...application, allergy: "yes"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputAllergyNo"
                        name={"inputAllergy"}
                        label={t('schema.breedreg.allergy.options.no')}
                        aria-describedby="allergyHelpBlock"
                        checked={application.allergy == "no"}
                        onChange={(e) => setApplication({...application, allergy: "no"})}
                    />
                </div>
                <div className="inputfield"> {/* Glaucoma */}
                    <Form.Label htmlFor="inputGlaucoma">{t('schema.breedreg.glaucoma.label')}</Form.Label>
                    <br />
                    <Form.Text id="glaucomaHelpBlock" muted>
                        {t('schema.breedreg.glaucoma.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputGlaucomaAffected"
                        name={"inputGlaucoma"}
                        label={t('schema.breedreg.glaucoma.options.affected')}
                        aria-describedby="glaucomaHelpBlock"
                        checked={application.glaucoma == "affected"}
                        onChange={(e) => setApplication({...application, glaucoma: "affected"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputGlaucomaCarrier"
                        name={"inputGlaucoma"}
                        label={t('schema.breedreg.glaucoma.options.carrier')}
                        aria-describedby="glaucomaHelpBlock"
                        checked={application.glaucoma == "carrier"}
                        onChange={(e) => setApplication({...application, glaucoma: "carrier"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputGlaucomaFree"
                        name={"inputGlaucoma"}
                        label={t('schema.breedreg.glaucoma.options.free')}
                        aria-describedby="glaucomaHelpBlock"
                        checked={application.glaucoma == "free"}
                        onChange={(e) => setApplication({...application, glaucoma: "free"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputGlaucomaNotTested"
                        name={"inputGlaucoma"}
                        label={t('schema.breedreg.glaucoma.options.nottested')}
                        aria-describedby="glaucomaHelpBlock"
                        checked={application.glaucoma == "nottested"}
                        onChange={(e) => setApplication({...application, glaucoma: "nottested"})}
                    />
                </div>
                <div className="inputfield"> {/* Dwarf Growth */}
                    <Form.Label htmlFor="inputDwarfGrowth">{t('schema.breedreg.dwarfgrowth.label')}</Form.Label>
                    <br />
                    <Form.Text id="dwarfGrowthHelpBlock" muted>
                        {t('schema.breedreg.dwarfgrowth.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputDwarfGrowthAffected"
                        name={"inputDwarfGrowth"}
                        label={t('schema.breedreg.dwarfgrowth.options.affected')}
                        aria-describedby="dwarfGrowthHelpBlock"
                        checked={application.dwarfGrowth == "affected"}
                        onChange={(e) => setApplication({...application, dwarfGrowth: "affected"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputDwarfGrowthCarrier"
                        name={"inputDwarfGrowth"}
                        label={t('schema.breedreg.dwarfgrowth.options.carrier')}
                        aria-describedby="dwarfGrowthHelpBlock"
                        checked={application.dwarfGrowth == "carrier"}
                        onChange={(e) => setApplication({...application, dwarfGrowth: "carrier"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputDwarfGrowthFree"
                        name={"inputDwarfGrowth"}
                        label={t('schema.breedreg.dwarfgrowth.options.free')}
                        aria-describedby="dwarfGrowthHelpBlock"
                        checked={application.dwarfGrowth == "free"}
                        onChange={(e) => setApplication({...application, dwarfGrowth: "free"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputDwarfGrowthNotTested"
                        name={"inputDwarfGrowth"}
                        label={t('schema.breedreg.dwarfgrowth.options.nottested')}
                        aria-describedby="dwarfGrowthHelpBlock"
                        checked={application.dwarfGrowth == "nottested"}
                        onChange={(e) => setApplication({...application, dwarfGrowth: "nottested"})}
                    />
                </div>
                <div className="inputfield"> {/* Other Sickness */}
                    <Form.Label htmlFor="inputOtherSickness">{t('schema.breedreg.othersickness.label')}</Form.Label>
                    <br />
                    <Form.Text id="otherSicknessHelpBlock" muted>
                        {t('schema.breedreg.othersickness.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputOtherSicknessNo"
                        name={"inputOtherSickness"}
                        label={t('schema.breedreg.othersickness.options.no')}
                        aria-describedby="otherSicknessHelpBlock"
                        checked={application.otherSickness == "no"}
                        onChange={(e) => setApplication({...application, otherSickness: "no"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputOtherSicknessYes"
                        name={"inputOtherSickness"}
                        label={t('schema.breedreg.othersickness.options.yes')}
                        aria-describedby="otherSicknessHelpBlock"
                        checked={application.otherSickness == "yes"}
                        onChange={(e) => setApplication({...application, otherSickness: "yes"})}
                    />
                    <Form.Control
                        id="inputOtherSicknessText"
                        aria-describedby="otherSicknessHelpBlock"
                        value={application.otherSicknessText}
                        onChange={(e) => setApplication({...application, otherSicknessText: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Confirmation */}
                    <Form.Label htmlFor="inputConfirmation">{t('schema.breedreg.confirmation.label')}</Form.Label>
                    <br />
                    <Form.Text id="confirmationHelpBlock" muted>
                        {t('schema.breedreg.confirmation.help')}
                    </Form.Text>
                    <Form.Check
                        type={'radio'}
                        id="inputConfirmationYes"
                        name={"inputConfirmation"}
                        label={t('schema.breedreg.confirmation.options.yes')}
                        aria-describedby="confirmationHelpBlock"
                        checked={application.confirmation == "yes"}
                        onChange={(e) => setApplication({...application, confirmation: "yes"})}
                    />
                    <Form.Check
                        type={'radio'}
                        id="inputConfirmationNo"
                        name={"inputConfirmation"}
                        label={t('schema.breedreg.confirmation.options.no')}
                        aria-describedby="confirmationHelpBlock"
                        checked={application.confirmation == "no"}
                        onChange={(e) => setApplication({...application, confirmation: "no"})}
                    />
                    <Form.Control
                        id="inputConfirmationText"
                        aria-describedby="confirmationHelpBlock"
                        value={application.confirmationText}
                        onChange={(e) => setApplication({...application, confirmationText: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Confirmation */}
                    <Form.Label htmlFor="inputConfirmation">{t('schema.breedreg.image.label')}</Form.Label>
                    <br />
                    <Form.Text id="confirmationHelpBlock" muted>
                        {t('schema.breedreg.image.help.male')}
                    </Form.Text>
                    <br />
                    <a href="https://www.dropbox.com/request/eAWqsA4fKosVElhILHlk" target="_blank">https://www.dropbox.com/request/eAWqsA4fKosVElhILHlk</a>
                    <br />
                    <br />
                    <Form.Text id="confirmationHelpBlock" muted>
                        {t('schema.breedreg.image.help.female')}
                    </Form.Text>
                    <br />
                    <a href="https://www.dropbox.com/request/bdls7o82fEyF6lg01nLm" target="_blank">https://www.dropbox.com/request/bdls7o82fEyF6lg01nLm</a>
                </div>
            </div>
        </SchemaBase>
    );
}

class SchemaBreedRegProps {
    
}

export default SchemaBreedReg;